var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.editing
    ? _c(
        "div",
        { staticClass: "tags" },
        [
          _vm.edit !== false
            ? _c(
                "a",
                {
                  staticClass: "edit",
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      _vm.editing = true
                    }
                  }
                },
                [_vm._v("Edit")]
              )
            : _vm._e(),
          _vm._v("\n  tags: \n  "),
          _vm._l(_vm.activeTags, function(tag, ti) {
            return [
              _c("a", [_vm._v(_vm._s(tag))]),
              _vm._v(
                _vm._s(_vm.activeTags.length - 1 > ti ? ", " : "") + "\n  "
              )
            ]
          })
        ],
        2
      )
    : _c("div", { staticClass: "tag-edit" }, [
        _c(
          "a",
          {
            staticClass: "edit",
            on: {
              click: function($event) {
                $event.preventDefault()
                _vm.editing = false
              }
            }
          },
          [_vm._v("Edit")]
        ),
        _vm._v(" "),
        _c("h3", [_vm._v("Select Tags")]),
        _vm._v(" "),
        _c(
          "ul",
          { staticClass: "tabs" },
          _vm._l(_vm.types, function(typeData, type) {
            return _c(
              "li",
              {
                class: { active: _vm.currentTab == type },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    _vm.currentTab = type
                  }
                }
              },
              [_vm._v("\n      " + _vm._s(typeData.label) + "\n    ")]
            )
          }),
          0
        ),
        _vm._v(" "),
        _vm.types[_vm.currentTab]
          ? _c(
              "ul",
              { staticClass: "items" },
              _vm._l(_vm.types[_vm.currentTab].items, function(item, ii) {
                return _c(
                  "li",
                  {
                    class: { active: _vm.isActive(_vm.currentTab, item.id) },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.toggleItem(_vm.currentTab, item.id)
                      }
                    }
                  },
                  [_vm._v("\n      " + _vm._s(item.title) + "\n    ")]
                )
              }),
              0
            )
          : _vm._e()
      ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }